import { catchError } from "../../utils/Helper";
import { deskEmails } from "../axios/endpoint";
import { getRequest, postRequest, putRequest, deleteRequest } from "../../components/axios/request";

export const getDeskEmails = async (query) => {
  try {
    const response = await getRequest(deskEmails.getDeskEmailList, query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getByEmailListId = async (id) => {
  try {
    const response = await getRequest(deskEmails.getByEmailListId(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getAssetList = async (id, query) => {
  try {
    const response = await getRequest(deskEmails.getAssetList(id), query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const docAssetMapping = async (query) => {
  try {
    const response = await putRequest(deskEmails.docAssetMapping, query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getDocumentView = async (id) => {
  try {
    const response = await getRequest(deskEmails.getDocumentView(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const closeTheDeskbyId = async (id) => {
  try {
    const response = await putRequest(deskEmails.closeDeskById(id), {
      status: "Close",
    });

    return response?.data;
  } catch (error) {
    console.log(error);
    throw catchError(error);
  }
};

export const assetUnMapping = async (data) => {
  try {
    const response = await putRequest(deskEmails.assetUnMapping, data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deskCustomerMap = async (id, data) => {
  try {
    const response = await putRequest(deskEmails.updateDeskCustomer(id), data);

    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const getFamilyName = async (email) => {
  try {
    const response = await getRequest(deskEmails.familyName(email));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const rejection = async (payload) => {
  try {
    const response = await putRequest(deskEmails.rejection, payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const getDeskDashboard = async (query) => {
  try {
    const response = await getRequest(deskEmails.getDeskDashboard, query);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const updateDocumentName = async (payload) => {
  try {
    const response = await putRequest(deskEmails.updateDocumentName(payload.documentId), payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const getMetrics = async (query) =>{
  try {
    const response = await getRequest(deskEmails.getMetrics, query)
    return response?.data
  } catch (error) {
    throw catchError(error)
  }
}
export const createTemplate = async (query) =>{
  try {
    const response = await postRequest(deskEmails.createTemplate, query)
    return response?.data
  } catch (error) {
    throw catchError(error)
  }
}
export const getTemplate = async (query) =>{
  try {
    const response = await getRequest(deskEmails.getTemplate, query)
    return response?.data
  } catch (error) {
    throw catchError(error)
  }
}
export const deleteTemplate = async (id) =>{
  try {
    const response = await deleteRequest(deskEmails.deleteTemplate(id))
    return response?.data
  } catch (error) {
    throw catchError(error)
  }
}
export const updateTemplate = async (id, payload) => {
  try {
    const response = await putRequest(deskEmails.updateTemplate(id), payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const sentTemplateMail = async (payload) => {
  try {
    const response = await postRequest(deskEmails.sentTemplateMail,payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deskApi = {
  getDeskEmails,
  getByEmailListId,
  closeTheDeskbyId,
  getAssetList,
  docAssetMapping,
  getDocumentView,
  assetUnMapping,
  deskCustomerMap,
  getFamilyName,
  rejection,
  getDeskDashboard,
  getMetrics,
  createTemplate,
  getTemplate,
  deleteTemplate,
  updateTemplate,
  sentTemplateMail,
  updateDocumentName
};
